<template>
  <PageLayout class="withdraw-requests-page">
    <WithdrawalRequests />
  </PageLayout>
</template>

<script>
import WithdrawalRequests from '../../views/withdrawal-requests/index.vue';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  components: { PageLayout, WithdrawalRequests },
};
</script>

<style lang="scss" scoped>
::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
